import { createFileRoute } from "@tanstack/react-router"
import { ShopifyAuthModal } from "modules/settings/components/integrations/shopify/ShopifyAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/shopify/connect")({
  component: ShopifyAuthModal,
})
